import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

interface ShortcutLozengeProps {
	children: string;
}

const styles = cssMap({
	lozenge: {
		paddingInlineStart: token('space.075'),
		paddingInlineEnd: token('space.075'),
		paddingBlockStart: token('space.025'),
		paddingBlockEnd: token('space.025'),
		backgroundColor: token('color.background.neutral'),
		color: token('color.text.subtle'),
		borderRadius: token('radius.small'),
		font: token('font.body.small'),
		fontWeight: token('font.weight.regular'),
	},
});

export const ShortcutLozenge = ({ children }: ShortcutLozengeProps) => (
	<Inline xcss={styles.lozenge}>{children}</Inline>
);
